import { CurriedFunction1 } from 'lodash'
import { createSelector } from 'reselect'
import { Finance } from '@homebot/shared-util-quartermaster'
import { selectNewHomeMortgageRate } from '../../mortgageRate'
import { newHome } from '../../../../constants/equity'
import { selectHomeValue } from '../metadata'
import { selectCashFromSale, asDownPaymentPercent } from './equity'

// TODO: TS build state interface
type State = any

const asDownPaymentPercent1: (next: number) => CurriedFunction1<any, number> =
  asDownPaymentPercent

export const selectNewHomeTotalEquity = selectCashFromSale

export const selectNewHomeBudget = createSelector<State, number>(
  selectNewHomeTotalEquity,
  (equity: number) => asDownPaymentPercent1(newHome.downPaymentPercent)(equity)
)

export const selectBuyerNewHomeBudgetWithCap = createSelector(
  selectNewHomeBudget,
  selectHomeValue,
  (budget, homeValue) => {
    const budgetCap = homeValue * newHome.budgetCap // cap at 150% of homeValue
    if (!budget || !homeValue) {
      return undefined
    }
    return budget <= budgetCap ? budget : budgetCap
  }
)

export const selectEightyLTVNewHomeMonthlyPayment = createSelector<
  State,
  number
>(selectBuyerNewHomeBudgetWithCap, selectNewHomeMortgageRate, (budget, rate) =>
  Finance.calculatePayment(
    budget * (1 - newHome.downPaymentPercent),
    newHome.loanTerm * 12,
    rate
  )
)
